import { Box, VStack, Heading, useToast, Center } from "@chakra-ui/react";
import ClawMachinePrizeForm from "./Form";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../consts/routes";
import usePrizes from "./hooks/usePrizes";
import { ClawMachinePrizeFormData } from "@olagg/validation-schemas";

const CreateClawMachinePrize = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const { createPrize } = usePrizes();

  const onSubmit = async (dataForm: ClawMachinePrizeFormData) => {
    try {
      await createPrize(dataForm);
      toast({
        title: 'Premio',
        colorScheme: 'olaggPink',
        status: 'success',
        description: `Premio creado con éxito`,
        position: 'bottom-right'
      });
      navigate(ROUTES.CLAW_MACHINE_PRIZES.all);
    } catch (error: any) {
      toast({
        title: 'Error',
        colorScheme: 'olaggYellow',
        status: 'error',
        description: error.message || 'Error al crear el premio',
        position: 'bottom-right'
      });
    }
  };

  return (
    <Center w={'full'} pb={4}>
      <VStack color={'white'} w={'full'}>
        <Heading my={2}>Crear Premio</Heading>
        <ClawMachinePrizeForm onSubmit={onSubmit} />
      </VStack>
    </Center>
  );
};

export default CreateClawMachinePrize;